export default "__VITE_ASSET__5KQEeOii__"